<template>
 <div class="purpose">
   <div class="title"><img src="../../assets/purpose.png" /></div>
   <div class="text">
     <p>蓝海密剑 重磅升级</p>
     <p>为私募行业赋能</p>
     <p>为财富管理通路</p>
   </div>
   <singup></singup>
 </div>
</template>
<script>
import singup from "../common/singup.vue"
export default {
  components:{
    singup
  }
}
</script>
<style scoped>
  .purpose {
    height: 100%;
    background: url("../../assets/purposebg.png") no-repeat center;
    background-size: cover;
    position: relative;
    text-align: center;
  }
  .title {
    padding-top: 10vh;
  }
  .title img {
    width: 43%;
  }
  .text {
    padding-top: 20vw;
    font-size: 6vw;
    font-weight: 900;
    color: #9ea4e1;
  }
  .text p {
    height: 15vw;
    line-height: 15vw;
    letter-spacing: 0.5vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/purpose.vue